module.exports = __webpack_public_path__ + "static/img/b16.d491754.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b16.jpg
// module id = HxDM
// module chunks = 1